// Signup.js
import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import API_BASE_URL from './baseurl'; // Adjust the import path as necessary



const Signup = () => {
  const [form, setForm] = useState({ username: '', password: '' });
  const [message, setMessage] = useState('');
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);


  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post(`${API_BASE_URL}/api/signup/`, form);
      setMessage('Signup successful!');
      setTimeout(() => setMessage(''), 3000);
      navigate('/login');
      setMessage(res.data.message);
    } catch (error) {
      setMessage(error.response?.data?.error || 'Signup failed');
      setTimeout(() => setMessage(''), 3000);
    }
    finally {
        setLoading(false); // ✅ Always stop loading
      }
  };

  return (
    <div className="container mt-5">
      <h2>Sign Up</h2>
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label>Username:</label>
          <input type="text" name="username" className="form-control" onChange={handleChange} required />
        </div>
        <div className="mb-3">
          <label>Password:</label>
          <input type="password" name="password" className="form-control" onChange={handleChange} required />
        </div>
        <button type="submit" className="btn btn-primary" disabled={loading}>
          {loading ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              Processing...
            </>
          ) : (
            'Sign Up'
          )}
        </button>
      </form>
      {message && <div className="alert mt-3 alert-info">{message}</div>}
    </div>
  );
};

export default Signup;
